/**
 * Push an event to the GTM dataLayer. Wrapped in try/catch so callers
 * (forms, link clicks, etc.) can never be blocked by tracking failures.
 *
 * The `window.dataLayer` global is declared by `@next/third-parties`.
 */
export function pushDataLayerEvent(payload: Record<string, unknown>): void {
	if (typeof window === "undefined") return;
	try {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(payload);
	} catch {
		// dataLayer push must never throw — user-facing actions must remain unaffected
	}
}
